import { Chip } from '@mui/material';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import {
  DriverSource,
  IDriverRatingSummary,
} from '../../../types/api/response/driverratingsresponse';

// Operators know the fleet, not the system: LOCUS is shown as "Internal" (Driver Ratings API TRD §6.3).
export const driverSourceLabel = (source: DriverSource | string): string => {
  switch (source) {
    case 'LOCUS':
      return 'Internal';
    case 'SUPERPRO':
      return 'SuperPro';
    default:
      return 'Unattributed';
  }
};

const sourceColor = (source: string): 'default' | 'primary' | 'secondary' => {
  switch (source) {
    case 'LOCUS':
      return 'primary';
    case 'SUPERPRO':
      return 'secondary';
    default:
      return 'default';
  }
};

export const getDriverRatingsColumns = (): GridColDef[] => [
  {
    field: 'driver_source',
    headerName: 'Fleet',
    flex: 0.7,
    renderCell: ({ value }: GridRenderCellParams) => (
      <Chip label={driverSourceLabel(value)} size="small" color={sourceColor(value)} />
    ),
  },
  {
    field: 'driver',
    headerName: 'Driver',
    flex: 1.4,
    valueGetter: (_, row: IDriverRatingSummary) => {
      if (row.driver_source === 'UNKNOWN') return 'No known driver';
      return row.driver_name ? `${row.driver_name} (${row.driver_id})` : row.driver_id;
    },
  },
  {
    field: 'average_rating',
    headerName: 'Average ★',
    flex: 0.6,
    valueFormatter: (value: number) => value.toFixed(2),
  },
  {
    field: 'rating_count',
    headerName: 'Ratings',
    flex: 0.5,
  },
  {
    field: 'last_rated_at',
    headerName: 'Last Rated',
    flex: 1,
    valueFormatter: (value: string | null) => (value ? new Date(value).toLocaleString() : '—'),
  },
];
